export default "__VITE_ASSET__DI57X0Xq__"